<h1>Changement du mot de passe</h1>
@if (!success) {
    @if (tokenExpiredError) {
        <ngb-alert type="danger">
            <strong>Demande expirée</strong>.&nbsp;<a [routerLink]="['/reinitialiser-mot-de-passe']">Cliquez ici</a>
            pour faire une nouvelle demande.
        </ngb-alert>
    }
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="my-4">
        <div class="row mb-3">
            <div class="col">
                <label>Nouveau mot de passe</label>
                <input-password formControlName="password"
                                [class.is-invalid]="$any(errors).plainPassword.password.length"/>
                @if ($any(errors).plainPassword.password.length) {
                    <div class="invalid-feedback">{{ $any(errors).plainPassword.password[0] }}</div>
                }
            </div>
        </div>
        <div class="row mb-3">
            <div class="col">
                <label>Confirmez le mot de passe</label>
                <input-password formControlName="confirmation"
                                [class.is-invalid]="$any(errors).plainPassword.confirmation.length"/>
                @if ($any(errors).plainPassword.confirmation.length) {
                    <div class="invalid-feedback">{{ $any(errors).plainPassword.confirmation[0] }}</div>
                }
            </div>
        </div>
        <div class="d-flex justify-content-between">
            <a [routerLink]="['/']" class="btn btn-secondary">Retour</a>
            <button type="submit" class="btn btn-primary" [disabled]="loading()">Envoyer</button>
        </div>
    </form>
}
@if (success) {
    <ngb-alert type="success">Votre mot de passe a été changé.</ngb-alert>
    <div class="d-flex">
        <button class="btn btn-primary mx-auto" [routerLink]="['/']">Se connecter</button>
    </div>
}
